import { AlertTriangle, Check, CircleDashed, Loader2 } from "lucide-react";

const STEPS = [
  { id: "payment_received", label: "Payment received" },
  { id: "code_preparing", label: "Code being prepared" },
  { id: "code_delivered", label: "Code delivered" },
];

export default function StatusTracker({ status, history = [] }) {
  if (status === "needs_support") {
    return (
      <div
        data-testid="delivery-status-tracker"
        className="flex items-center gap-3 rounded-xl border border-amber-500/30 bg-amber-500/[0.07] px-4 py-3.5"
      >
        <AlertTriangle className="h-5 w-5 shrink-0 text-amber-400" />
        <div>
          <p className="text-sm font-medium text-amber-200">Delivery needs support</p>
          <p className="text-xs text-amber-200/70">
            We hit a snag sending your code. Reach out via Telegram or email and we'll fix it fast.
          </p>
        </div>
      </div>
    );
  }

  const currentIndex = STEPS.findIndex((s) => s.id === status);
  const timeFor = (id) => (history.find((h) => h.status === id) || {}).at;

  return (
    <div data-testid="delivery-status-tracker" className="flex flex-col gap-0">
      {STEPS.map((step, i) => {
        const done = currentIndex >= i;
        const current = currentIndex === i;
        const at = timeFor(step.id);
        return (
          <div key={step.id} className="flex gap-3.5" data-testid={`status-step-${step.id}`}>
            <div className="flex flex-col items-center">
              <span
                className={`flex h-7 w-7 items-center justify-center rounded-full border ${
                  done
                    ? "border-primary/60 bg-primary/15 text-primary"
                    : "border-white/15 bg-white/[0.03] text-muted-foreground"
                }`}
              >
                {done && !current && <Check className="h-3.5 w-3.5" />}
                {done && current && step.id !== "code_delivered" && (
                  <Loader2 className="h-3.5 w-3.5 animate-spin" />
                )}
                {done && current && step.id === "code_delivered" && <Check className="h-3.5 w-3.5" />}
                {!done && <CircleDashed className="h-3.5 w-3.5" />}
              </span>
              {i < STEPS.length - 1 && (
                <span className={`h-7 w-px ${done && currentIndex > i ? "bg-primary/50" : "bg-white/10"}`} />
              )}
            </div>
            <div className="pb-1 pt-1">
              <p className={`text-sm ${done ? "text-foreground" : "text-muted-foreground"}`}>{step.label}</p>
              {at && (
                <p className="text-[11px] text-muted-foreground/70">
                  {new Date(at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
